export const BLACK_100 = '#0F1E24';
export const BLACK_90 = '#1E2C32';
export const WHITE_100 = '#FFF';
export const WHITE_80 = 'rgba(255, 255, 255, 0.80)';

// Error colors (based on design system #E44F40)
export const ERROR_100 = '#E44F40';
export const ERROR_BG = '#FFECEC';
export const ERROR_BORDER = ERROR_100;
export const ERROR_TEXT = '#7A6500';
export const ERROR_HOVER = '#FFECEC';

// Warning colors (based on design system #CFA901)
export const WARNING_100 = '#CFA901';
export const WARNING_BG = '#FDF8E6';
export const WARNING_BORDER = WARNING_100;
export const WARNING_TEXT = '#7A6500';
export const WARNING_HOVER = '#F5EBC4';

// Success colors (based on design system #5AAC23)
export const SUCCESS_100 = '#5AAC23';
export const SUCCESS_BG = '#F3FBE8';
export const SUCCESS_BORDER = SUCCESS_100;
export const SUCCESS_TEXT = '#27611A';
export const SUCCESS_HOVER = '#E8F5E9';

// Info colors
export const INFO_100 = '#4F6564';
export const GREY_100 = '#A5B8AC';
export const GREY_90 = '#717773';
export const GREY_80 = '#DADFDB';
export const GREY_70 = '#F8FAF8';
export const GREY_30 = '#4F6564';
export const GREY_BORDER = '#DFE5E2';
export const GREY_BACKGROUND_HOVER = '#F0F3F2';
export const GREY_SUBTLE = '#7F8885';
// TODO consolidate these greens for consistency
export const GREEN_BUTTON = '#26A993';
export const GREEN_BUTTON_DARK = '#229884';
export const GREEN_NAV = '#054A41';
export const GREEN_TERTIARY = '#E9F5F0';
export const GREEN_TAB = '#135450';
export const GREEN_100 = '#2A413C';
export const GREEN_95 = '#3A5952';
export const GREEN_80 = '#D3F3C7';
export const GREEN_70 = '#ECF2EA';
export const GREEN_60 = '#77B65A';
export const GREEN_50 = '#C3F1D7';
export const FLUX_DRAWER_WIDTH = '21rem';
export const COPILOT_DRAWER_WIDTH = '21.75rem';
export const COPILOT_DRAWER_WIDTH_MIN = 348; // 21.75rem in px
export const COPILOT_DRAWER_WIDTH_MAX = 800; // 50rem in px
export const COMMENT_DRAWER_WIDTH = '21rem';
export const HISTORY_DRAWER_WIDTH = '21rem';
export const LEFT_NAVIGATION_WIDTH = '280px';
export const APP_HEADER_HEIGHT = '56px';
export const DOCUMENT_TOOLBAR_HEIGHT = '3.5rem';
export const DRAWER_MARGIN_TOP = `calc(${APP_HEADER_HEIGHT} + ${DOCUMENT_TOOLBAR_HEIGHT})`;
export const DARK_TEXT_COLOR = '#162523';
export const DISABLED_TEXT_COLOR = '#9CA5A2';

// Penny thinking state color — intentionally distinct from TEAL_PRIMARY.
// Balances gray (recedes in importance) with green (signals InscopeAI/Penny).
// Designed for legibility at small text sizes where existing palette colors
// were either too low-contrast or too saturated.
export const PENNY_THINKING = '#36817A';

export const TEAL_PRIMARY = '#34A290';
export const TEAL_PRIMARY_DARK = '#2D8F7D';
export const TEAL_PRIMARY_DISABLED = '#B6D7D0';
export const TEAL_PRIMARY_LIGHT = '#DEF1E9';
export const TEAL_PRIMARY_LIGHTER = '#EAF8F4';
export const TEAL_PRIMARY_ALPHA = 'rgba(52, 162, 144, 0.04)';

export const GREY_TEXT_SECONDARY = '#67716E';
export const GREY_BACKGROUND_LIGHT = '#F5F5F5';
export const GREY_BACKGROUND_HOVER_LIGHT = '#F9F9F9';
export const GREY_BORDER_LIGHT = '#E0E0E0';
export const GREY_BORDER_DEFAULT = '#E1E5E4';
export const GREY_BORDER_LIGHTER = '#CDD3D3';

export const FOOTER_HEIGHT =
  process.env.REACT_APP_ENVIRONMENT === 'production' ? '0rem' : '2.25rem';

export const COPILOT_COLORS = {
  primary: TEAL_PRIMARY,
  primaryHover: TEAL_PRIMARY_DARK,
  primaryLight: TEAL_PRIMARY_ALPHA,
  chipBg: TEAL_PRIMARY_LIGHT,
  textPrimary: DARK_TEXT_COLOR,
  textSecondary: GREY_TEXT_SECONDARY,
  hoverBg: GREY_BACKGROUND_HOVER_LIGHT,
  iconButtonBorder: GREY_BORDER_LIGHT,
  iconButtonHover: GREY_BACKGROUND_LIGHT,
  white: WHITE_100,
  transparent: 'transparent',
  background: {
    light: GREY_BACKGROUND_LIGHT,
    white: WHITE_100,
  },
  text: {
    primary: DARK_TEXT_COLOR,
    secondary: GREY_TEXT_SECONDARY,
    label: BLACK_100,
  },
  border: {
    default: GREY_BORDER_DEFAULT,
    light: GREY_BORDER_LIGHTER,
  },
};

export const COPILOT_TYPOGRAPHY = {
  small: {
    fontSize: '12px',
    lineHeight: '1.4',
  },
  medium: {
    fontSize: '14px',
    lineHeight: '1.5',
  },
  label: {
    fontSize: '1rem',
    lineHeight: '150%',
    fontWeight: 500,
  },
  weights: {
    regular: 400,
    medium: 500,
    semibold: 600,
  },
};
